import gql from "graphql-tag";
export const contacts = id =>
  `{
  allContacts(where: {id: ${id}}) {
    totalCount
    Contacts {
      id
      linkedinid
      campaignid
      profileimage
       image
      name
      invitationsent
     currentstatus
      profileurl
      email
      industry
      dateofbirth
      organization
      Campaigns: campaignIbfk4rel {
        Campaigns {
          name
          customerid
          status
          active
          Customers: customerIbfk1rel {
            Customers {
              company
            }
          }
        }
      }
      designation
      joiningdate
      headline
      lasteducationinstitute
      twitter
      skype
      phonenumber
      phonetype
      numberoffollowers
      connectedon
      location
      createdon
      contactstatus
      campaignstatus
      updatedon
      active
    }
  }
}
`;

export const CustomerInfo = `query($where:JSON){
  allCampaigns(where:$where){
    Campaigns{
      customerIbfk1rel{
        Customers{
          company
          id
        }
      }
    }
  }
}
`;

export const campaign = id => ` {
  Customers(id: ${id}) {
    id
    company
    campaignfk(where: {order: name}) {
      Campaigns {
        id
        name
      }
    }
  }
}`;

export const allcampaigns = gql`
  query($where: JSON) {
    allCampaigns(where: $where) {
      totalCount
      Campaigns {
        id
      }
    }
  }
`;
export const allcompanys = gql`
  query($where: JSON) {
    allContactscompanies{
      totalCount
      Contactscompanies{
        id
        name
      }
    }
  }
`;

export const Company = gql`
  query($where: JSON) {
    allCustomers(where: $where) {
      Customers {
        id
        company
      }
    }
  }
`;
// profile
export const ManagersName = gql`
  query($where: JSON) {
    allCampaigns(where: $where) {
      Campaigns {
        id
        name
        linkedinid
        customercredentialsIbfk1rel {
          Customerlinkedinprofiles {
            id
            name
          }
        }
      }
    }
  }
`;

export const ProfileName = gql`
  query($where: JSON) {
    allCustomers(where: $where) {
      Customers {
        id
        company
        Customerlinkedinprofilesfk {
          Customerlinkedinprofiles {
            name
            id
            Campaignsfk {
              Campaigns {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const ManagerName = gql`
  query($where: JSON) {
    allCampaigns(where: $where) {
      Campaigns {
        id
        customerid
        name
      }
    }
  }
`;
